import {Component, Input, ViewChild} from '@angular/core';
import {IonInput, ModalController} from '@ionic/angular';
import {BaseModalComponent} from '../base-modal.component';

@Component({
    selector: 'bb-table-marker-entry',
    templateUrl: './table-marker-entry.component.html',
    styleUrls: ['./table-marker-entry.component.scss'],
})
export class TableMarkerEntryComponent extends BaseModalComponent {

    @ViewChild('manualAmount') set first(input: IonInput) {
        if (!!input) {
            setTimeout(async () => {
                await input.setFocus();
            }, 250);
        }
    }

    @Input() marker: number;
    @Input() notes: string;
    @Input() required = false;
    @Input() min: number;
    @Input() max: number;
    @Input() label: string;
    @Input() subHeader: string;

    constructor(modalController: ModalController) {
        super(modalController);
    }

    submit() {
        this.close({marker: this.marker, notes: this.notes});
    }
}
